import type { IProposal } from "../../../../types/models/proposals.modals.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  proposal: IProposal;
}

export function useGetProposalByIdAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/campaigns/proposals/:proposalId",
  });
}
